import {commonWebSocket} from '@services/common/common.constants';
import { initWebsocket, websocketAuthenticated, websocketDisconnected, websocketLoginFailed } from '@services/common/common.action';
import {createReducer} from 'redux-act';
import TranslateNew from '@translate/TranslateNew';
import { activateEmailAddress, emailAddressActivationFinished, IEmailAddressActivation } from './user.actions';

interface IState {
  authenticated: boolean,
  loadCompleted: boolean,
  // The server reported a LOGIN error since the last successful login. Kept
  // across reconnects so the loading screen stays up until a login succeeds.
  loginFailed: boolean,
  emailActivation?: IEmailAddressActivation & {pending: boolean; failed: boolean},
};

const defaultState:IState= {
  authenticated: false,
  loadCompleted: false,
  loginFailed: false,
};

const reducer = createReducer<IState>({}, defaultState);

reducer

  .on(initWebsocket, (state:IState) => {
    return {
      ...state,
      authenticated: false,
      loadCompleted: false,
      emailActivation: undefined,
    };
  })
  .on(websocketDisconnected, (state:IState) => {
    return {
      ...state,
      authenticated: false,
      loadCompleted: false,
      emailActivation: undefined,
    };
  })
  .on(websocketLoginFailed, (state:IState) => {
    return {
      ...state,
      loginFailed: true,
    };
  })
  .on(websocketAuthenticated, (state:IState) => {
    return {
      ...state,
      authenticated: true,
    };
  })
  .on(activateEmailAddress, (state, payload) => {
    if (state.emailActivation?.pending) { return state; }
    return {
      ...state,
      emailActivation: { ...payload, pending: state.authenticated, failed: !state.authenticated },
    };
  })
  .on(emailAddressActivationFinished, (state, payload) => {
    if (state.emailActivation?.requestId !== payload.requestId) { return state; }
    return {
      ...state,
      emailActivation: { ...state.emailActivation, pending: false, failed: payload.failed },
    };
  })
  .on(commonWebSocket.special.REQUEST_ID, (state:IState, payload:any) => {
    let loadCompleted = state.loadCompleted;
    let authenticated = !!state.authenticated;
    let loginFailed = !!state.loginFailed;
    if (payload.requestId && payload.requestId === "AUTH") {
      authenticated = true;
    } else if (payload.requestId && payload.requestId === "LOGIN" && !payload.hasError) {
      authenticated = true;
      loadCompleted = true;
      loginFailed = false;
    }

    return {
      ...state,
      authenticated,
      loadCompleted,
      loginFailed,
    };

  });


export default reducer;



// WEBPACK FOOTER //
// ./src/services/user/connection.reducer.ts